import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, map, of } from "rxjs";


export interface IPage {
    first: string;
    last: string;
    next: string;
    previous: string;
}

export class Response<T> {
    public data?: Array<T> | T;
    public pages?: IPage;
    public total?: number;
    public service: Service<T>;

    constructor(data: Array<T> | T, pages: any, total: number, service: Service<T>) {
        this.data = data;
        if(pages) {
            this.pages = {
                first: pages["hydra:first"],
                last: pages["hydra:last"],
                next: pages["hydra:next"],
                previous: pages["hydra:previous"]
            };
        }
        this.total = total;
        this.service = service;
    }

    next(): Observable<Response<T>> {
        if(this.pages?.next) {
            return this.service.next(this.pages.next);
        } else {
            return of(this);
        }
    }
}

export abstract class Service<T> {

    protected abstract readonly URL: string;

    constructor(protected httpClient: HttpClient) {}

    getAll(filters: string = ""): Observable<Response<T>> {
        return this.httpClient.get(`${this.URL}${filters}`).pipe(
            map((res: any) => new Response<T>(
                res["hydra:member"],
                res["hydra:view"],
                res["hydra:totalItems"],
                this
            ))
        ) as Observable<Response<T>>;
    };

    get(id: number): Observable<T> {
        return this.httpClient.get(`${this.URL}/${id}`) as Observable<T>;
    };

    save(item: T): Observable<T> {
       return this.httpClient.post(`${this.URL}`, item) as Observable<T>;
    };
    
    edit(item: T, id: number): Observable<T> {
        return this.httpClient.put(`${this.URL}/${id}`, item) as Observable<T>;
    };
    
    patch(item: Partial<T>, id: number): Observable<T> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/merge-patch+json',
        });
        return this.httpClient.patch(`${this.URL}/${id}`, item, { headers: headers }) as Observable<T>;
    };

    delete(id: number): Observable<T> {
        return this.httpClient.delete(`${this.URL}/${id}`) as Observable<T>;
    }

    next(url: string): Observable<Response<T>> { 
        return this.httpClient.get(url).pipe(
            map((res: any) => new Response<T>(
                res["hydra:member"],
                res["hydra:view"],
                res["hydra:totalItems"],
                this
            ))) as Observable<Response<T>>;
    }
}
